<template>
  <div class="attendee-selector-view">
    <modal-frame :showModalFlag="true" :position="'fullscreen'">
      <div class="selection-header">
        <h1>通話参加者選択</h1>
        <div class="controll">
          <button class="select-cancel-btn" @click="selectionCancel">閉じる</button>
          <button class="select-finish-btn" :class="{enable: attendeeSelected}" @click="selectionFinish">チェックした相手を呼び出す</button>
        </div>
      </div>
      <div class="selection-body">
        <div 
          class="category-block"
          v-for="category in addressBook"
          :key="'sadrctg' + category.id"
          >
          <div class="category-title">
            <span class="category-name">{{ category.name }}</span>
          </div>
          <div class="entry-block"
            v-for="entry in category.address_entries"
            :key="'sadrent' + entry.id">
            <div class="entry-info-block" @click="toggleSelect(entry)">
              <span class="selected-flag">
                <custom-check-box
                  :type="'small'"
                  :active="isSelected(entry)"
                  :enabled="!alreadySelected(entry)"
                  />
              </span>
              <span class="entry-icon" :class="{ disable: alreadySelected(entry) }"><user-portrate :target="entry" :displaySize="'mini'"/></span>
              <span class="entry-name" :class="{ disable: alreadySelected(entry) }">{{ entry.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </modal-frame>
    <confirm-dialog
      :showDialog="confirmDialogVisible"
      :title="confirmDialogTitle"
      :message="confirmDialogMessage"
      :dialogType="confirmDialogType"
      v-on:negativeResultEvent="confirmFinishNegative"
      v-on:positiveResultEvent="confirmFinishPositive"
      />
  </div>
</template>

<script>
import { PhoneCall } from '@/api'
import { mapState, mapActions } from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'
import UserPortrate from '@/components/appView/common/UserPortrate.vue'
import CustomCheckBox from '@/components/common/CustomCheckBox.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

import ConfirmDialogControll from '@/mixin/ConfirmDialogControll'

// import * as DIALOG_TYPE from '@/assets/constants/dialogType.js'

export default {
  mixins: [ ConfirmDialogControll ],

  name: 'AttendeeSelectorView',

  components: {
    ModalFrame,
    UserPortrate,
    CustomCheckBox,
    ConfirmDialog,
  },

  data () {
    return {
      presetAttendees: [],
      selectedAttendees: [],
      phoneCallID: null,
    }
  },

  watch: {
    '$route': { handler: 'storeQuery', immediate: true },
    // presentedAttendees: { handler: 'initAttendee', immediate: true },
    // device: { handler: 'fireFinishedEvent', immediate: true }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      currentDevice: state => state.user.currentDevice,
      availableUsers: state => state.user.users,
      addressBook: state => state.addressBook.addressCategories,
    }),

    attendeeSelected () {
      if (this.selectedAttendees.length > 0) {
        return true
      }
      return false
    }
  },

  methods: {
    ...mapActions({
      fetchUserByNarrativePhoneID: 'user/fetchByNarrativePhoneID',
    }),

    async storeQuery () {
      console.log(this.$route.query)
      // pathでアクセスした場合
      if (this.$route.query.attendees) {
        // attendeesをカンマで区切って取得
        console.log(this.$route.query.attendees)
        // fetchUserByNarrativePhoneIDで取得、デバイス登録ユーザーがいないかチェック。
        let attendeeIDList = this.$route.query.attendees.split(',')
        for(let attID of attendeeIDList) {
          console.log(attID)
          await this.fetchUserByNarrativePhoneID({ narrativePhoneID: attID }).then(attendee => {
            if (attendee) {
              this.presetAttendees.push(attendee)
            }
          }).catch(err => {
            console.error(err)
          })
        }
        console.log(this.presetAttendees)
        if (this.presetAttendees.length <= 0) {
          this.$native.event('attendeeSelectionParameterError', 'no preset attendees.')
          this.showNotifyDialog(
            "パラメーターが正しくありません", 
            '通話先追加のためのパラメータ[attendees]が正しく指定されていません。',
          )
        }
      } else {
        // MEMO: 失敗イベント
        this.$native.event('attendeeSelectionParameterError', 'parametor [attendees] MUST exist.')
        this.showNotifyDialog(
          "パラメーターが正しくありません", 
          '通話先追加のためのパラメータ[attendees]が正しく指定されていません。',
        )
      }
      // console.log(this.$route.query.phone_call_id)
      // console.log(parseInt(this.$route.query.phone_call_id))
      // console.log(isNaN(parseInt(this.$route.query.phone_call_id)))
      if (this.$route.query.phone_call_id && !isNaN(parseInt(this.$route.query.phone_call_id))) {
        this.phoneCallID = this.$route.query.phone_call_id
        // console.log(this.phoneCallID)
      } else {
        this.$native.event('attendeeSelectionParameterError', 'parametor [phone_call_id] MUST exist.')
        this.showNotifyDialog(
          "パラメーターが正しくありません", 
          '通話先追加のためのパラメータ[phone_call_id]が正しく指定されていません。',
        )
      }
    },

    alreadySelected (attendee) {
      return this.presetAttendees.some((pAttend) => pAttend.narrative_phone_id === attendee.narrative_phone_id)
    },

    isSelected (attendee) {
      return this.selectedAttendees.some((sAttend) => sAttend.narrative_phone_id === attendee.narrative_phone_id)
    },

    toggleSelect (attendee) {
      if (!this.alreadySelected(attendee)) {
        let aIndex = this.selectedAttendees.findIndex(sAtt => sAtt.narrative_phone_id === attendee.narrative_phone_id)
        console.log(aIndex)
        if (aIndex >= 0) {
          this.selectedAttendees.splice(aIndex, 1)
        } else {
          if (this.selectedAttendees.length + this.presetAttendees.length <= 8) {
            this.selectedAttendees.push(attendee)
          } else {
            this.showNotifyDialog('通話先件数', '通話先に追加できる人数は合計8名まで(' + (8 - this.presetAttendees.length) + ')です')
          }
        }
      }
    },

    async selectionFinish () {
      // request to api,
      if (this.attendeeSelected) {
        let successAttendees = []
        let failedAttendees = []
        for(let attendee of this.selectedAttendees) {
          await PhoneCall.addAttendee({ phoneCallID: this.phoneCallID, attendeeNPID: attendee.narrative_phone_id }).then(res => {
            console.log(res)
            successAttendees.push(attendee)
          }).catch(error => {
            console.error(error)
            failedAttendees.push(attendee)
          })
        }
        // send native event.
        let selectedAttendees = {
          attendees: successAttendees.map((att) => ({ narrative_phone_id: att.narrative_phone_id, name: att.name })),
          failed_attendees: failedAttendees.map((att) => ({ narrative_phone_id: att.narrative_phone_id, name: att.name }))
        }
        console.log('gonna send native event attendeeSelectedEvent')
        console.log(selectedAttendees)
        this.$native.event('attendeeSelectedEvent', selectedAttendees)
      }
    },

    selectionCancel () {
      console.log('close event fire.')
      this.$native.event('attendeeSelectedEvent', { attendees: [], failed_attendees: [] })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.attendee-selector-view {
  margin: 0;
  .selection-header {
    padding: 15px;
    padding-bottom: 0;
    h1 {
      margin: 0;
      font-size: 22pt;
      font-weight: normal;
    }
    .controll {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      .select-cancel-btn {
        padding: 5px 8px 3px;
        border-radius: 5px;
        background-color: #fff;
        border: 1px solid $normal-btn-color;
        color: $normal-btn-color;
        font-weight: bold;
      }
      .select-finish-btn {
        padding: 5px 8px 3px;
        border-radius: 5px;
        background-color: $disable-btn-color;
        border: 1px solid $phone-main-color;
        color: $normal-btn-text-color;
        font-weight: bold;
        font-size: 1.1rem;
        &.enable {
          background-color: $phone-main-color;
          border: 1px solid $phone-main-color;
        }
      }
    }
  }
  .selection-body {
    padding: 20px 10px;
    max-height: calc(100vh - 240px);
    overflow: auto;
    .category-block {
      .category-title {
        border-bottom: 1px solid #aaa;
      }
      .entry-block {
        margin: 20px 0;
        .entry-info-block {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .selected-flag {
            margin-right: 10px;
          }
          .entry-icon {
            margin-right: 10px;
            &.disable {
              opacity: 0.5;
            }
          }
          .entry-name {
            font-size: 16pt;
            &.disable {
              color: #aaa;
            }
          }
        }
      }
    }
  }
}
</style>